var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloudPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1378_6348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 11.4933H12.374C14.0928 11.4933 15.499 10.5805 15.499 8.88079C15.499 7.1811 13.8428 6.33485 12.499 6.26829C12.2212 3.61016 10.2803 1.99329 7.99902 1.99329C5.84277 1.99329 4.45402 3.42422 3.99902 4.84329C2.12402 5.02141 0.499023 6.21454 0.499023 8.16829C0.499023 10.122 2.18652 11.4933 4.24902 11.4933H5.99902",
    stroke: "#821C6B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 7.99369L8.00028 5.99341L6 7.99369",
    stroke: "#821C6B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0065V6.49341",
    stroke: "#821C6B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1378_6348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudPrimary);
export default __webpack_public_path__ + "static/media/ic-cloud-primary.8fbad665c4f123dae0040eb6aaa86455.svg";
export { ForwardRef as ReactComponent };